module.exports = __webpack_public_path__ + "media/images/welcome_screen-e019160ebd8caaecd02d075f72ab04d0.png";